define('SageDotCom/Components/DynamicProductCard/PriceBox',["jquery", "eventManager", "SageDotCom/Components/ProductCardAlignment", "SageDotCom/Utility/sanitizer", 'visitorIdCookie'],
    function ($, eventManager, productCardAlignment, sanitizer, visitorIdCookie) {
        function PriceBox(scope, productSku, promoLabel, promoCodeOverwrite, freeLabel, isPreview) {
            visitorIdCookie.CheckAndSetCookie();

            const promoOverwrite = promoCodeOverwrite.trim();

            if ($(".dynamic-product-card-updater").length) {
                window.productCardUpdater_productSku = productSku;
                window.productCardUpdater_promoLabel = promoLabel;
                window.productCardUpdater_promoOverwrite = promoOverwrite;
                eventManager.trigger("priceBoxInstanciated");
            }

            var locale = undefined;
            var productprice = undefined;

            var pricebox = $(scope).find(".dynamic-product-card-price-box");

            if (isPreview) {
                const currentUrl = new URL(window.location.href);
                locale = currentUrl.searchParams.get("sc_lang");
            }

            if (typeof (locale) === "undefined") {
                const localeArr = document.location.pathname.split("/");
                for (let i = 0; i < localeArr.length; i++) {
                    if (localeArr[i] !== "") {
                        locale = localeArr[i];
                        break;
                    }
                }
            }

            const ignorePromo = $(scope).find(".dynamic-product-card-price-box").hasClass("no-promo");

            $.ajax({
                type: "GET",
                url: `/sitecore/api/product/DynamicPriceBoxData/${productSku}/${locale}`,
                data: {
                    promoCodeOverwrite: promoOverwrite,
                    ignorePromo: ignorePromo,
                    promoHtmlTemplate: sanitizer.sanitizeHtml(promoLabel)
                },
                context: this
            }).done((response) => {
                const jsonObj = JSON.parse(response);
                if (!ignorePromo && jsonObj.Promo) {

                    jsonObj.Promo.PromoHtml = sanitizer.sanitizeHtml(jsonObj.Promo.PromoHtml);
                    $(scope).find(".sage-dynamic-product-card-promotion-banner").html(jsonObj.Promo.PromoHtml);
                    $(scope).find(".sage-dynamic-product-card-promo").html(jsonObj.Promo.PromoHtml).show();
                    $(scope).find(".sage-dynamic-product-card.sage-product-card-price-box").addClass("promo");
                    $(scope).find(".dynamic-product-card-price-box").attr("data-href", jsonObj.BuyUrl);
                    //make sure buy+promo url is added to button data-href for datalayer/tracking
                    if (pricebox.parents(".sage-product-card-outer").find(".dynamic-product-card-modal-launch-btn") != undefined) {
                        pricebox.parents(".sage-product-card-outer").find(".dynamic-product-card-modal-launch-btn").attr("data-href", jsonObj.BuyUrl);
                    }


                    if ($(pricebox).hasClass("display-discount-number") ||
                        $(pricebox).hasClass("display-discount-text") ||
                        $(pricebox).hasClass("display-discount-and-rrp")) {

                        if ($(pricebox).hasClass("display-discount-text") && jsonObj.Promo.DiscountedPrice === 0) {
                            productprice = freeLabel;
                        } else {
                            productprice = jsonObj.Promo.FormattedDiscountedPrice;
                        }
                    } else {
                        // must be default of display rrp chosen
                        productprice = jsonObj.FormattedPrice;
                    }
                } else {
                    if ($(pricebox).hasClass("display-rrp-text") && jsonObj.Price === 0) {
                        productprice = freeLabel;
                    } else {
                        productprice = jsonObj.FormattedPrice;
                    }
                }

                if (jsonObj.PriceDemoted || $(pricebox).hasClass("display-discount-and-rrp")) {
                    $(scope).find(".main-price-line").addClass("has-demoted-price");
                    $(scope).find(".sage-product-card-demoted-price").html(jsonObj.FormattedRRPPrice);
                }

                $(scope).find(".sage-product-card-price-alt").html(productprice);

                // repopulate comparison table header if Price Box component is inside comparison table
                if ($(scope).parents(".product-comparison-table") !== null && $(scope).parents(".product-comparison-table").length > 0) {
                    // only fire if there is not a bundled price box on the card
                    var parentCard = $(scope).parents(".sage-product-card-outer");
                    if (parentCard.find(".sage-product-card-bundle-price-box") === null || parentCard.find(".sage-product-card-bundle-price-box").length === 0) {
                        eventManager.trigger("populate-comparison-header", null, $(scope));
                    }
                }
                productCardAlignment.sageProductCardMatchHeight();
            });
        }

        PriceBox.init = (args) => {
            return args.IsEditorEditing === true
                ? null
                : new PriceBox(args.scope, args.productSku, args.promoLabel, args.promoCodeOverwrite, args.freeLabel, args.isPreview);
        };

        return PriceBox;
    });
